<template>
    <div class="app-container">
        <!-- 顶部标题 -->
        <div class="header">业务办理大厅</div>


            <!-- 账户余额卡片 -->
            <div class="balance-card">
                <div class="balance-amount">¥ {{ useeData?.money }}</div>
                <div class="balance-label">我的资金</div>
            </div>

            <!-- 订单卡片容器 -->
            <div class="cards-container">
                <!-- 教育类 -->
                <div class="order-card" v-for="item in gameList" :key="item.id" @click="goDetail(item)">
                    <div class="card-tag">{{ item.name }}</div>
                    <div class="card-content">
                        <div class="card-left">
                            <div class="card-title">实时标的</div>
                            <div class="card-number">{{ item.next_issue }}</div>
                        </div>
                        <div class="card-right">
                            <div class="card-amount">480</div>
                            <!-- <div class="card-icon">¥</div> -->
                        </div>
                    </div>
                </div>

            </div>

        <tab-bar></tab-bar>

    </div>
</template>

<script setup>
import TabBar from "@/components/tabbar/TabBar.vue";
import { useRouter } from 'vue-router'
import homeApi from "@/api/home";
import userApi from "@/api/user";
import { onMounted, ref } from "vue";

const router = useRouter()

onMounted(async () => {
    await getLotteryinfo()
    await getUserInfo()
    onRefresh()
})

const isLoading = ref(false)
const onRefresh = () => {
    isLoading.value = true
    setTimeout(() => {
        isLoading.value = false
    }, 1000)
};

const gameList = ref([])
const getLotteryinfo = async () => {
    const res = await homeApi.gamelist()
    if (res.code == 1) {
        // 按weigh大小排序（从大到小）
        gameList.value = res.data.sort((a, b) => b.weigh - a.weigh)
        console.log(gameList.value)
    }
}

const useeData = ref()
const getUserInfo = async () => {
    const res = await userApi.userInfo()
    if (res.code == 1) {
        useeData.value = res.msg
        console.log(gameList.value)
    }
}

const goDetail = (item) => {
    router.push({
        path: '/lotteryDetail',
        query: { id: item.id }
    })
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.app-container {
    min-height: 100vh;
    background-color: #0a1628;
    /* padding: 0 10px; */
    color: #ffffff;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    overflow-y: auto; /* 允许纵向滚动 */
    padding-bottom: 80px; /* 为底部tabbar留出空间 */
}

/* 顶部标题 */
.header {
    text-align: center;
    padding: 16px 0;
    font-size: 18px;
    font-weight: 500;
    background-color: #1a1d3a;
}

/* 账户余额卡片 */
.balance-card {
    margin: 20px 16px;
    background: linear-gradient(135deg, #2a2d4a 0%, #1f2238 100%);
    border-radius: 16px;
    padding: 20px 20px;
    text-align: center;
    position: relative;
    overflow: hidden;
}

.balance-card::before {
    content: '';
    position: absolute;
    width: 200px;
    height: 200px;
    background: rgba(255, 255, 255, 0.03);
    border-radius: 50%;
    top: -100px;
    left: -50px;
}

.balance-card::after {
    content: '';
    position: absolute;
    width: 150px;
    height: 150px;
    background: rgba(255, 255, 255, 0.03);
    border-radius: 50%;
    bottom: -70px;
    right: -40px;
}

.balance-amount {
    font-size: 48px;
    font-weight: 600;
    margin-bottom: 8px;
    position: relative;
    z-index: 1;
}

.balance-label {
    font-size: 14px;
    color: #b8bbcc;
    position: relative;
    z-index: 1;
}

/* 卡片容器 */
.cards-container {
    padding: 0 16px 20px;
}

/* 订单卡片 */
.order-card {
    background: url('~@/assets/image/dt-1.png') no-repeat center center;
    background-size: cover;
    border-radius: 16px;
    padding: 32px;
    margin-bottom: 16px;
    position: relative;
    overflow: hidden;
    color: white;
}

.order-card::before {
    content: '';
    position: absolute;
    width: 120px;
    height: 120px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    top: -30px;
    right: -20px;
}

.order-card::after {
    content: '';
    position: absolute;
    width: 100px;
    height: 100px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
    bottom: -40px;
    left: -30px;
}

/* 卡片标签 */
.card-tag {
    text-align: center;
    font-size: 30px;
    font-weight: 500;
    margin-bottom: 10px;
    position: relative;
    z-index: 1;
    color: #fb9c9c;
    transform: translateY(-20px); /* 往上移动5px */
}

/* 卡片内容 */
.card-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 1;
    transform: translateY(-30px); /* 往上移动5px */
}

.card-left {
    text-align: left; /* 左对齐 */
    margin-left: -10px; /* 往左移10px */
}

.card-title {
    font-size: 19px;
    font-weight: 500;
    margin-bottom: 8px;
}

.card-number {
    font-size: 16px;
    color: #404040;
}

.card-right {
    display: flex;
    align-items: center;
    gap: 12px;
    transform: translateY(-15px); /* 往上移动5px */
}

.card-amount {
    font-size: 24px;
    /* font-weight: 600; */
}

.card-icon {
    width: 56px;
    height: 56px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    font-weight: 600;
}

/* 响应式 */
@media (max-width: 480px) {
    .balance-amount {
        font-size: 42px;
    }

    .card-amount {
        font-size: 22px;
    }

    .card-icon {
        width: 50px;
        height: 50px;
        font-size: 24px;
    }
    
    .app-container {
        padding-bottom: 70px; /* 在小屏幕上调整底部padding */
    }
}
</style>